import { render, staticRenderFns } from "./SubHead.vue?vue&type=template&id=6b98139f&scoped=true&"
import script from "./SubHead.vue?vue&type=script&lang=js&"
export * from "./SubHead.vue?vue&type=script&lang=js&"
import style0 from "./SubHead.vue?vue&type=style&index=0&id=6b98139f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b98139f",
  null
  
)

export default component.exports